import {
  NavExternalLink,
  isNavExternalLink,
} from "types/CMS/KontentAI/content-types/external_link";
import {
  NavInternalLink,
  isNavInternalLink,
} from "types/CMS/KontentAI/content-types/internal_link";
import { isPageGeneral } from "types/CMS/KontentAI/content-types/general_page";
import { link } from "types/CMS/Unum/link";
import { urlHierarchyTraversal } from "./urlHierarchy";
import { createResolver } from "./Factories/ResolverFactory";
import { isPageHardcoded } from "types/CMS/KontentAI/content-types/hardcoded_page";

export const linkResolver = createResolver({
  resolve: (link: NavInternalLink | NavExternalLink): link => {
    if (isNavExternalLink(link)) {
      return {
        type: "external",
        label: link.elements.label.value,
        url: link.elements.url.value,
      };
    }
    if (isNavInternalLink(link))
      return internalLinkResolver.resolve(link).result;

    return {
      type: "unknown",
      label: "",
      url: "",
    };
  },
});

export const internalLinkResolver = createResolver({
  resolve: (links: NavInternalLink): link => {
    const { elements } = links;
    let url: string = "/";

    if (isPageHardcoded(elements.page.linkedItems[0])) {
      url = elements.page.linkedItems[0].elements.url_path.value;
    }

    if (isPageGeneral(elements.page.linkedItems[0])) {
      url = "/" + urlHierarchyTraversal(elements.page.linkedItems[0]).join("/");
    }

    return {
      type: "internal",
      label: elements.label.value,
      url: url,
    };
  },
});
